
import Vue from "vue";
import AlertMessage from "@/components/templates/AlertMessage.vue";
import NavigationDrawer from "@/components/templates/NavigationDrawer/NavigationDrawer.vue";
import WebphoneFloating from "@/views/conf/webphone/Webphone.vue";
import Top from "./components/templates/Top.vue";
import store from "@/store/index";
import { mapActions, mapGetters } from "vuex";

export default Vue.extend({
  name: "App",

  components: {
    AlertMessage,
    NavigationDrawer,
    Top,
    WebphoneFloating,
  },

  computed: {
    ...mapGetters({
      user: "auth/user",
      corp: "auth/corp",
      webPhone: 'auth/webPhone',
    }),
  },
});
